'use client';

import React from 'react';
import { Target, Rocket } from 'lucide-react';

export const ScenarioExplainer: React.FC = () => {
  return (
    <div className="my-12 space-y-6">
      {/* Paid Ads Only Card */}
      <div className="bg-gradient-to-br from-purple-50 to-white border-2 border-purple-100 rounded-lg p-6">
        <div className="flex items-start gap-4">
          <div className="flex-shrink-0">
            <div className="w-12 h-12 rounded-lg bg-purple-100 flex items-center justify-center">
              <Target className="w-6 h-6 text-purple-600" />
            </div>
          </div>
          <div>
            <h3 className="text-xl font-bold text-neutral-900 mb-2">
              Paid Ads Only
            </h3>
            <p className="text-neutral-700 leading-relaxed">
              represents what most loan officers experience - direct return from ad spend. You pay for clicks, some become leads, a few become loans. With excellent execution, this can be profitable. With average execution, it's often break-even or negative.
            </p>
          </div>
        </div>
      </div>

      {/* Hybrid System Card */}
      <div className="bg-gradient-to-br from-green-50 to-white border-2 border-green-100 rounded-lg p-6">
        <div className="flex items-start gap-4">
          <div className="flex-shrink-0">
            <div className="w-12 h-12 rounded-lg bg-green-100 flex items-center justify-center">
              <Rocket className="w-6 h-6 text-green-600" />
            </div>
          </div>
          <div>
            <h3 className="text-xl font-bold text-neutral-900 mb-2">
              The Hybrid System
            </h3>
            <p className="text-neutral-700 leading-relaxed">
              shows what happens when those same leads activate multiple revenue streams. You're not just converting the leads you bought. You're creating a compound effect where leads generate partnerships, partnerships generate referrals, closed loans generate more referrals, and your market visibility drives organic traffic.
            </p>
          </div>
        </div>
      </div>

      {/* Gap Statement */}
      <div className="bg-neutral-50 border-l-4 border-primary-500 p-6 rounded-r-lg">
        <p className="text-lg text-neutral-700 leading-relaxed">
          The gap between these scenarios isn't theoretical. It's money that's either flowing into your business or going to competitors who understand leverage better. The{' '}
          <a
            href="/guide/mortgage-marketing-strategies"
            className="text-primary-600 font-semibold hover:underline"
          >
            complete playbook walks through each of the five channels
          </a>{' '}
          that closes it.
        </p>
      </div>
    </div>
  );
};
